<template>
    <!-- 首页(未登录) -->
    <div class="index">
        <div class="pc-header">
            <!-- 首页一个导航 -->
            <div class="flex align-items" v-if="getPath == '/index'">
                <header
                    class="menu flex justify-center fs16 align-items navNew"
                    :class="{ sticky: isSticky, 'bg-white': showBg }"
                >
                    <div class="mr104" v-if="showBg == false"></div>
                    <div class="mr104" v-if="showBg == true"></div>
                    <router-link
                        v-for="item in routerList"
                        :key="item.path"
                        :to="item.path"
                    >
                        <div
                            v-if="showBg == false"
                            :class="[
                                'menu-item',
                                { 'menu-active': item.path === getPath }
                            ]"
                        >
                            {{ item.name }}
                        </div>

                        <div
                            v-if="showBg == true"
                            :class="[
                                'menu-items',
                                { 'menu-actives': item.path === getPath }
                            ]"
                        >
                            {{ item.name }}
                        </div>
                    </router-link>

                    <div class="userAll" v-if="!userStore.token">
                        <!-- token -->
                        <router-link to="/login">
                            <div class="flex-center">
                                <div class="menu-item3 login">登录</div>
                            </div>
                        </router-link>
                        <router-link to="/register">
                            <div
                                class="menu-item2 reginster"
                                v-if="showBg == false"
                            >
                                注册
                            </div>
                            <div class="reginster2" v-if="showBg == true">
                                注册
                            </div>
                        </router-link>
                    </div>
                    <div class="userAll" v-else>
                        <div @click="loginSuccess">
                            <div class="flex-center">
                                <button class="menu-item2 reginster">
                                    前往后台
                                </button>
                            </div>
                        </div>
                    </div>
                </header>
            </div>

            <!-- 其他的导航部分 -->
            <div class="flex align-items" v-else>
                <header
                    class="menu2 flex justify-center fs16 align-items navNew"
                    :class="{ sticky: isSticky, 'bg-white': showBg }"
                >
                    <div class="mr104" v-if="showBg == false">
                        <img
                            :src="config.company?.website_logo"
                            style="width: 45px; height: 44px"
                        />
                    </div>
                    <div class="mr104" v-if="showBg == true">
                        <img
                            :src="config.company?.website_logo"
                            style="width: 45px; height: 44px"
                        />
                    </div>
                    <router-link
                        v-for="item in routerList"
                        :key="item.path"
                        :to="item.path"
                    >
                        <div
                            v-if="showBg == false"
                            :class="[
                                'menu-item',
                                { 'menu-active': item.path === getPath }
                            ]"
                        >
                            {{ item.name }}
                        </div>

                        <div
                            v-if="showBg == true"
                            :class="[
                                'menu-items',
                                { 'menu-actives': item.path === getPath }
                            ]"
                        >
                            {{ item.name }}
                        </div>
                    </router-link>

                    <div class="userAll" v-if="!userStore.token">
                        <router-link to="/login" target="_blank">
                            <div class="flex-center">
                                <div class="menu-item3 login">登录</div>
                            </div>
                        </router-link>
                        <router-link to="/register" target="_blank">
                            <div
                                class="menu-item2 reginster"
                                v-if="showBg == false"
                            >
                                注册
                            </div>
                            <div class="reginster2" v-if="showBg == true">
                                注册
                            </div>
                        </router-link>
                    </div>
                    <div class="userAll" v-else>
                        <div @click="loginSuccess">
                            <div class="flex-center">
                                <button class="menu-item2 reginster">
                                    前往后台
                                </button>
                            </div>
                        </div>
                    </div>
                </header>
            </div>
        </div>
        <!-- 手机端 -->
        <div class="mobile-header">
            <div class="mobile-nav flex items-center justify-between">
                <div
                    class="mobile-opt flex items-center"
                    v-if="!userStore.token"
                >
                    <router-link to="/login" target="_blank">
                        <div class="login-btn mr-4 px-4 py-1 mobile-op-btn">
                            登录
                        </div>
                    </router-link>
                    <router-link to="/register" target="_blank">
                        <div class="register-btn mr-4 px-4 py-1 mobile-op-btn">
                            注册
                        </div>
                    </router-link>
                </div>
                <div v-else>
                    <div @click="loginSuccess">
                        <button class="back-btn mr-4 px-4 py-1 mobile-op-btn">
                            前往后台
                        </button>
                    </div>
                </div>
                <div
                    class="mobile-right flex items-center"
                    @click="showMobileMenu = !showMobileMenu"
                >
                    <el-icon size="26px"><Expand /></el-icon>
                </div>
            </div>
            <div class="mobile-menu" v-if="showMobileMenu">
                <router-link
                    v-for="item in routerList"
                    :key="item.path"
                    :to="item.path"
                    @click="showMobileMenu = false"
                >
                    <div
                        :class="[
                            'mobile-menu-item',
                            { 'mobile-menu-active': item.path === getPath }
                        ]"
                    >
                        {{ item.name }}
                    </div>
                </router-link>
            </div>
        </div>
        <!-- 占位符 -->
        <router-view></router-view>
    </div>
</template>

<script lang="ts" setup>
import { PageEnum } from '@/enums/pageEnum'
import useAppStore from '@/stores/modules/app'
import { computed, ref, reactive } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import useUserStore from '@/stores/modules/user'
import { loginSuccess } from '@/utils/routerTo'
// import { storeToRefs } from 'pinia'

const userStore = useUserStore()

const router = useRouter()
const route = useRoute()
const appStore = useAppStore()
const config = computed(() => appStore.reConfig)

const getPath = ref(route.path)
router.afterEach((route) => {
    getPath.value = route.path
})

const routerList = reactive([
    { show: true, path: PageEnum.INDEX, name: '首页' },
    { show: true, path: PageEnum.LATEST_NOTICE, name: '最新公告' },
    { show: true, path: PageEnum.FILING_FLOW, name: '备案流程' },
    { show: true, path: PageEnum.LAWS_REGULATIONS, name: '法律法规' },
    {
        show: true,
        path: PageEnum.SYSTEM_HELP,
        name: '系统帮助'
    }
])

const isSticky = ref(false)
const showBg = ref(false)

const showMobileMenu = shallowRef(false)

// function handleScroll() {}

const handleScroll = () => {
    const threshold = 100 // 设置当滚动超过100px时显示白色背景
    isSticky.value = window.scrollY > threshold
    showBg.value = window.scrollY > threshold
}

onMounted(() => {
    window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
})
</script>

<style lang="scss" scoped>
.menu {
    background-color: transparent;
}
.menu2 {
    background-color: #0b61d2;
}
.menu-item {
    // color: #000;
    color: #d0d0d0;
    padding: 38px 40px;
}

.menu-active {
    color: #fff;
}

.menu-items {
    color: #434343;
    padding: 38px 40px;
}

.menu-actives {
    color: #0b61d2;
}
.index {
    // min-width: 1400px;
    position: relative;
    background-color: #f5f5f5;
    min-height: 100vh;
}
header {
    // height: 75px;
    // background-color: #fff;
}
.fs16 {
    font-size: 16px;
}
.align-items {
    align-items: center;
}
.mr104 {
    margin-right: 64px;
}

.userAll {
    display: flex;
    margin-left: 200px;
}

.menu-item:hover {
    color: #fff;
}
.menu-item2 {
    // color: #000;
    // padding: 5px 20px;
    border-radius: 2px;
    background: #f5f5f5;
    width: 88px;
    height: 40px;
    color: #353536;
    line-height: 40px;
    text-align: center;
    margin-left: 29px;
}

.menu-item2:hover {
    color: #f4a647;
}

.reginster2 {
    border-radius: 2px;
    background: #4a76f4;
    width: 88px;
    height: 40px;
    color: #fff;
    line-height: 40px;
    text-align: center;
    margin-left: 29px;
}

.activeTab {
    color: #0b61d2;
}
.userimg {
    width: 24px;
    height: 24px;
}
.flex-center {
    display: flex;
    align-items: center;
}
.menu-item3 {
    // padding: 5px 20px 5px 10px;
    width: 88px;
    height: 40px;
    color: #fff;
    line-height: 40px;
    text-align: center;
    border-radius: 2px;
    background: rgba(0, 0, 0, 0.4);
}

.menu-item3:hover {
    color: #f4a647;
}

.navNew {
    // position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 999;
    // min-width: 1400px;
    position: fixed;
}

.sticky {
    width: 100%;
    top: 0;
    left: 0;
    z-index: 999;
    // min-width: 1400px;
    position: fixed;
}

.bg-white {
    background-color: white;
}

.content {
    position: absolute;
    top: 183px;
    z-index: 999;
    left: 0;
    width: 100%;
    min-width: 1400px;
    cursor: pointer;
    user-select: none;
}
.w-500 {
    width: 605px;
}
.h-104 {
    height: 104px;
}
.rightimg {
    width: 432px;
    margin-left: 160px;
    cursor: pointer;
}
.text {
    color: #fff;
    font-size: 48px;
    cursor: pointer;
}
.text2 {
    color: #fff;
    font-size: 18px;
    margin-top: 10px;
    cursor: pointer;
}

.part1 {
    width: 44px;
    height: 44px;
}
.part2 {
    width: 40px;
    height: 40px;
}
.part3 {
    width: 48px;
    height: 48px;
}
.detailPart {
    min-width: 1400px;
    width: 100%;
    position: absolute;
    top: 590px;
    z-index: 10;
}

.small-x {
    min-width: 1200px;
}

.fourWH {
    background-color: #fff;
    width: 288px;
    height: 92px;
    border-radius: 4px;
    box-shadow: 0px 2px 8px 0px rgba(11, 38, 222, 0.25);
}

.ml22 {
    margin-left: 22px;
}

.fs18 {
    font-size: 18px;
}

.fs14 {
    font-size: 14px;
}

.color1 {
    color: #1c1c1c;
}
.color2 {
    color: #7a7a7a;
}

.bold {
    font-weight: bold;
}
@media screen and (min-width: 1201px) {
    .pc-header {
        display: block;
    }
    .mobile-header {
        display: none;
    }
}
@media screen and (max-width: 1200px) {
    .pc-header {
        display: none;
    }
    .mobile-header {
        display: block;
    }
    .index {
        min-width: 100%;
        overflow: hidden;
    }
}
.mobile-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    z-index: 999999;
}
.mobile-nav {
    height: 60px;
    width: 100%;
    padding: 20px;
}
.login-btn {
    background-color: #999999;
}
.register-btn {
    background-color: #4a5dff;
}
.back-btn {
    background-color: #67c23a;
}
.mobile-op-btn {
    text-align: center;
    color: #fff;
    border-radius: 4px;
}
.mobile-menu {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    background-color: #fff;
    border-top: 1px solid #999;
    padding: 10px 20px;
}
.mobile-menu-item {
    padding: 8px 0;
    border-bottom: 1px solid #ccc;
}
.mobile-menu-active {
    color: #4a5dff;
    font-weight: 700;
}
</style>
